import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { DealersService } from './dealers.service';

angular.module('app-lite.dealers', [])
  .service('dealersApi', downgradeInjectable(DealersService));
